import { createClient } from '@supabase/supabase-js';

// Publishable config — safe to ship in the client bundle.
// Row-Level Security on Supabase protects all data; this key only allows
// RLS-scoped access (a user can only ever see/modify their own rows).
// Overridable via REACT_APP_ env vars if ever needed.
const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://rrxfnkpwjehjmujfyhob.supabase.co';

const SUPABASE_PUBLISHABLE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  'sb_publishable_pL6HOhvOq9oLcItiOfhyOQ_aW5zN8zw';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export default supabase;
